import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ErroService } from '@app/services/erro.service';
import { SaidaErro } from '@models/Erro';

@Component({
  selector: 'app-log-excecao',
  templateUrl: './log-excecao.component.html',
  styleUrls: ['./log-excecao.component.css']
})
export class LogExcecaoComponent implements OnInit {
  displayedColumns: string[] = ['codigo', 'erro', 'dataHora'];
  erros: SaidaErro[];

  constructor(private erroService: ErroService,               
              private router: Router) { }

  ngOnInit() {
    this.erroService.ConsultaErros(0).subscribe(retorno => {
      this.erros = retorno.erros;
    });
  }

  buscarErro(codigo) {
    this.erroService.ConsultaErros(+codigo).subscribe(retorno => {
      this.erros = retorno.erros;
    });
  }
}
